<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
              <div class="title">地图搜索定位</div>
              <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body" style="height: 400px">

              <div>
                  <baidu-map class="bm-view" :center="centerName" :zoom="12"
                      :scroll-wheel-zoom="true" @click="getClickInfo">

                    <bm-view style="width: 100%; height:500px;"></bm-view>

                    <bm-marker
                        :position="{ lng: centerStr.lng, lat: centerStr.lat }"
                        :dragging="true"
                        animation="BMAP_ANIMATION_BOUNCE">
                    </bm-marker>

                    <bm-control :offset="{ width: '10px', height: '10px'}">
                        <bm-auto-complete v-model="addressInfo" :sugStyle="{ zIndex: 999999 }">
                            <el-input v-model="addressInfo" placeholder="请输入搜索关键字" style="margin:10px 0 0 10px">
                                <template slot="prepend"><span>地址搜索：</span></template>
                            </el-input>
                        </bm-auto-complete>
                    </bm-control>

                    <bm-local-search
                          :keyword="addressInfo"
                          :auto-viewport="true"
                          style="width:0px;height:0px;overflow: hidden;">
                      </bm-local-search>

                  </baidu-map>
              </div>

            </div>
            <div class="modal-footer">
                <el-row style="width:100%">
                    <el-col :span="21">
                        <el-col :span="24" style="padding:0 5px ">
                            <el-input v-model="addressInfo" disabled>
                                <template slot="prepend"><span>所选地址：</span></template>
                            </el-input>
                        </el-col>
                    </el-col>
                    <el-col :span="3">
                        <el-button style="float: right;margin-right:10px" type="primary" @click="confirm('addForm')">添加</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>

import BaiduMap from 'vue-baidu-map/components/map/Map.vue'

export default {
    name: "addHospital",
    data() {
        return {
            mapZoom: 15,
            mapCenter: { lng: 0, lat: 0 },
            addressInfo:'',
            door:'',
            initCity:'',
            address:'',
            centerName:'',
            mapLocation: {
                address: undefined,
                coordinate: undefined
            },
            keyword: "",
            centerStr: {
                lng: "",
                lat: ""
            }
        };
    },
    components: {
        BaiduMap
    },
    methods: {
        closeSelf(){
            this.$emit('colseMap')
        },
        getClickInfo(e) {
            this.centerStr.lng = e.point.lng;
            this.centerStr.lat = e.point.lat;
        },
        // syncCenterAndZoom(e) {
        //     const { lng, lat } = e.target.getCenter();
        //     this.centerStr.lng = lng;
        //     this.centerStr.lat = lat;
        //     this.zoom = e.target.getZoom();
        // },
        init(data){
            this.mapLocation.address=undefined
            this.addressInfo=undefined
            this.address=undefined
            this.centerName=data
            this.initCity=data
        },
        // handlerBMap({ BMap, map }) {
        //     this.BMap = BMap
        //     this.map = map
        //     if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
        //         this.mapCenter.lng = this.mapLocation.coordinate.lng
        //         this.mapCenter.lat = this.mapLocation.coordinate.lat
        //         this.mapZoom = 15
        //         map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate))
        //     } else {
        //         this.mapCenter.lng = 113.271429
        //         this.mapCenter.lat = 23.135336
        //     }
        // },
        // querySearch(queryString, cb) {
        //     var that = this
        //     var myGeo = new this.BMap.Geocoder()
        //     myGeo.getPoint(queryString, function(point) {
        //         if (point) {
        //             that.mapLocation.coordinate = point
        //             that.makerCenter(point)
        //         } else {
        //             that.mapLocation.coordinate = null
        //         }
        //     }, this.locationCity)
        //     var options = {
        //         onSearchComplete: function(results) {
        //             if (local.getStatus() === 0) {
        //                 // 判断状态是否正确
        //                 var s = []
        //                 for (var i = 0; i < results.getCurrentNumPois(); i++) {
        //                     var x = results.getPoi(i)
        //                     console.log(x)
        //                     var item = { value:x.title, point: x.point }
        //                     s.push(item)
        //                 }
        //                 cb(s)
        //             } else {
        //                 cb()
        //             }

        //         }
        //     }
        //     var local = new this.BMap.LocalSearch(this.map, options)
        //     local.search(queryString)
        // },
        // handleSelect(item) {
        //     var { point } = item
        //     this.mapLocation.coordinate = point
        //     this.makerCenter(point)
        //     console.log(point)
        //     var myGeo = new this.BMap.Geocoder();      
        //     // 根据坐标得到地址描述    
        //     myGeo.getLocation(new this.BMap.Point(point.lng, point.lat), function(result){      
        //         if (result){      
        //             console.log(result)  
        //         }      
        //     });
        //     this.addressInfo=item.value
        // },
        // makerCenter(point) {
        //     if (this.map) {
        //         this.map.clearOverlays()
        //         this.map.addOverlay(new this.BMap.Marker(point))
        //         this.mapCenter.lng = point.lng
        //         this.mapCenter.lat = point.lat
        //         this.mapZoom = 15
        //     }
        // },

        confirm(){

            if(!this.addressInfo){
                this.$message({type: 'info', message: '请选择地址'});
                return;
            }

            var mapCenter={
                lng: this.centerStr.lng, lat:this.centerStr.lat,addressInfo:this.addressInfo
            }

            console.log(mapCenter)

            this.$emit('setMap',mapCenter)

        }

  }
};

</script>




<style lang="scss" scoped>
</style>
